module.exports = __webpack_public_path__ + "img/btn-icon-4.ba6aad40.png";